import React from "react";
import {isViewVisible} from "../../../utils/ViewSettings";
import AbonnementsView from "./abonnements/AbonnementsView";
import AbonnementsUsersView from "./abonnements_users/AbonnementsUsersView";
import {createSubmenuItems} from "../../../utils/Helper";
import Rbac from "../../../utils/Rbac";

export const rbac = new Rbac({
    _rbac: {
        "admin": {
            editAbonnement: true,
            addAbonnement: true,
            deleteAbonnement: true
        },
        "manager": {
            editAbonnement: true,
            addAbonnement: true,
            deleteAbonnement: true
        },
        "manager-location": {
            editAbonnement: false,
            addAbonnement: false,
            deleteAbonnement: false
        },
        "user": {
            editAbonnement: false,
            addAbonnement: false,
            deleteAbonnement: false
        },
        "garage-staff": {
            editAbonnement: false,
            addAbonnement: false,
            deleteAbonnement: false
        }
    }
});
export const AbonnementsPage  = (props:any) => {
    let _view: string = typeof props.view === 'undefined' || props.view === null ? 'index' : props.view;
    return (
        <>
            {_view === 'abonnements' && isViewVisible('abonnements','contingents') &&
                <AbonnementsView
                    name={"abonnements"}
                    dispatch={props.dispatch}
                    params={props.params}
                    returnPath={props.returnPath}
                    rbac={rbac}
                    states={props.states}
                    submenuitems={createSubmenuItems('abonnements')}
                    createAccessBar={props.createAccessBar}
                />
            }
            {_view === 'abonnementsUsers' && isViewVisible('abonnementsUsers','contingents') &&
                <AbonnementsUsersView
                    name={"abonnementsUsers"}
                    dispatch={props.dispatch}
                    params={props.params}
                    returnPath={props.returnPath}
                    rbac={rbac}
                    states={props.states}
                    submenuitems={createSubmenuItems('abonnements')}
                    createAccessBar={props.createAccessBar}
                />
            }
        </>
    );
}